import type { HostType } from 'configs/theme'

type LegalDocuments = {
  offer?: string
  privacyPolicy?: string
}

export const legalDocumentsByHost: Partial<Record<HostType, LegalDocuments>> = {
  sellmonitor: {
    offer: '/public-offer/',
    privacyPolicy: '/doc/sellmonitor/ru/privacy_policy.pdf',
  },
  vtb: {
    offer: '/public-offer/',
    privacyPolicy: '/doc/sellmonitor/ru/privacy_policy.pdf',
  },
  mayak: {
    offer:
      'https://docs.google.com/document/d/1t-3wGfb7gBpG3E9DWYxpzUgNxMsYLIDTgZKAl2m2sj4/edit?tab=t.0',
    privacyPolicy:
      'https://docs.google.com/document/d/1QIWnKoIUtVcbSU5QGPg3sArYo5DVvTIF_9V5HaNByaY/edit?tab=t.0',
  },
  sellscreen: {
    offer: '/doc/sellscreen/en/terms.pdf',
    privacyPolicy: '/doc/sellscreen/en/privacy_policy.pdf',
  },
  sellematics: {
    privacyPolicy: '/doc/sellematics/ru/privacy_policy.pdf',
  },
}

export const getLegalDocuments = (hostType: HostType) => legalDocumentsByHost[hostType] ?? {}
